import React from 'react'
import { useTheme } from 'styled-components'
import { defaultFaIconCx } from './style'

type Props = React.HTMLAttributes<HTMLElement>

const FaBuilding = ({ style, ...props }: Props) => {
  const theme = useTheme() as any
  const mergedClassName = ['fa-regular fa-building', defaultFaIconCx].join(' ')

  return (
    <i
      className={mergedClassName}
      style={!style ? { color: theme.table.text } : style}
      {...props}></i>
  )
}

export default React.memo(FaBuilding)
